import React from 'react';
import { FileTextIcon, PhoneIcon } from 'lucide-react';
import { site } from '../data/site';
export function MobileCallBar() {
  return <div className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-2 gap-2 border-t border-line bg-white p-2.5 shadow-[0_-6px_20px_rgba(11,15,23,0.12)] lg:hidden" data-id="element-215" data-mp="2sc4kxlp86g42">
      <a href={site.phoneHref} className="flex items-center justify-center gap-2 rounded-lg bg-ink py-3 font-display text-lg font-bold text-white" data-id="element-216" data-mp="2idp3kag02l7r">
        <PhoneIcon className="h-5 w-5" aria-hidden="true" data-id="element-217" data-mp="29dsa7vio0y6d" /> Call Now
      </a>
      <a href="#quote" className="flex items-center justify-center gap-2 rounded-lg bg-brand py-3 font-display text-lg font-bold text-white" data-id="element-218" data-mp="29fv7n0m5dtl4">
        <FileTextIcon className="h-5 w-5" aria-hidden="true" data-id="element-219" data-mp="1zoqu85c4egse" /> Free Quote
      </a>
    </div>;
}